import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { Drawer } from "@outpave/ds";
import SubscriptionsTable from "components/admin/subscriptions/SubscriptionsTable";
import { LISTABLE_SUBSCRIPTION_STATUSES } from "enums/Subscription";

interface PaymentLinkSubscribersDrawerProps {
  open: boolean;
  paymentLinkId: string | null;
  paymentLinkName?: string;
  readOnly: boolean;
  onClose: () => void;
}

const PaymentLinkSubscribersDrawer: React.FC<
  PaymentLinkSubscribersDrawerProps
> = ({ open, paymentLinkId, paymentLinkName, readOnly, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Drawer
      open={open}
      onClose={onClose}
      width={720}
      title={
        paymentLinkName ? [t("Subscribers"), paymentLinkName] : t("Subscribers")
      }
      footer={
        <Button variant="default-outlined" onClick={onClose}>
          {t("Close")}
        </Button>
      }
    >
      {paymentLinkId && (
        <SubscriptionsTable
          filterCriteria={{
            status: LISTABLE_SUBSCRIPTION_STATUSES,
            paymentLinkId,
          }}
          refreshIndex={0}
          readOnly={readOnly}
          onViewDetails={(subscriptionId) =>
            navigate(`/admin/subscriptions?id=${subscriptionId}`)
          }
          onRefresh={() => undefined}
        />
      )}
    </Drawer>
  );
};

export default PaymentLinkSubscribersDrawer;
